import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_Input from "../templates/K_Input";
import { ComponentOptions } from "./component";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface ColorInputOptions extends InputOptions, kendo.ui.ColorPickerOptions {
    downArrowText?: string;
    displayWidth?: number;
}

export class ColorInput extends TemplateComponent {

    options: ColorInputOptions;

    constructor(options: ColorInputOptions) {
        super(K_Input, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.title = buildDataBindSyntax(options.label, "text");
        options.required = options.required || false;
        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        options.downArrowText = options.downArrowText || "Select Color";
        options.placeholder = options.placeholder || "";

        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.iconType = options.iconType || "";
        options.displayWidth = options.displayWidth || 300;
    }

    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }

        const options = this.options;

        var numericInput = $("#" + this.id).kendoColorPicker(options).data("kendoColorPicker");

        if (options.disabled && numericInput) {
            numericInput.enable(!options.disabled);
        }

        if (options.readonly && numericInput) {
            (numericInput as any).readonly();
            numericInput.element.readOnly(true);
        }

        var numericInputValue = "";

        $("#" + this.id).on("change", function (e) {

            numericInputValue = $("#" + this.id).val();

            if (numericInputValue.trim().length == 0) {
                $("#" + this.id).val("");
            }

        });
    }

}
